import { useState, useEffect } from "react";
import {
  TextField,
  MenuItem,
  Grid,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  Button,
  Checkbox,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import { ErrorCard, LoadingCard, MainContainer } from "../../components";
import { usePost, useFetchWithBody } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { setDetailParams, setNewEntryMode } from "../../state/outstandingBillEntrySlice";

const getAcTypeFromBillType = (billType) => {
  switch (billType) {
    case "P": return 11;
    case "S": return 13;
    case "PR": return 12;
    case "SR": return 14;
    case "I": return 16;
    case "J": return 15;
    default: return null;
  }
};

const OutstandingBillEntry = () => {
  const { compCode, startDate } = useSelector((state) => state.company);
  const [submitbtnid, setSubmitbtnid] = useState("")
  const [dateError, setDateError] = useState(null);
  //const [openDialog, setOpenDialog] = useState(false);
  const { detailParams, isNewEntry } = useSelector((state) => state.outstandingBillEntry);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Ac_Year = 2;
  const DY = 1;
  const [formData, setFormData] = useState({
    Ac_Year,
    CompCode: compCode,
    DY,
    Bill_Type: "",
    Trade_Of: "",
    Ac_Id: "",
    PAc_Id: "",
    Bill_Date: null,
    Bill_No: "",
    Br_Id: "",
    NETAMTD: "",
    CRATE: "",
    NetAmt: "",
    BillYN: "1",
    Remark: "",
    TransactionID: "",
  });


  const handleDateChange = (newValue) => {
    //if (startDate && startDate != "") {
    const start = new Date(startDate);
    const billDate = new Date(newValue)
    if (billDate >= start) {
      setDateError(`Bill date must be before company start date (${formatToDDMMYY(startDate)})`);
    }
    else
      setDateError(null)

    setFormData((prev) => {
      return {
        ...prev,
        Bill_Date: newValue != '' && newValue != 'Invalid Date' ?
          dayjs(newValue).format("YYYY-MM-DD") : null,
      };
    })

  }

  const [filters, setFilters] = useState({ acType: null, tradeOf: "" });

  useEffect(() => {
    const acType = getAcTypeFromBillType(formData.Bill_Type);
    setFilters({ acType, tradeOf: formData.Trade_Of });
  }, [formData.Bill_Type, formData.Trade_Of]);

  const { data: partyData = [] } = useFetchWithBody({
    url: apiRoute.transactionEntry.getParties,
    queryKey: ["accountList", filters.acType, filters.tradeOf],
    inputData: { compCode, acType: filters.acType, tradeOf: filters.tradeOf },
    enabled: !!filters.acType && !!filters.tradeOf,
  });

  const { data: brokerList = [] } = useFetchWithBody({
    url: apiRoute.transactionEntry.getBrokerList,
    queryKey: ["brokers", compCode],
    inputData: { compCode },
  });

  const { data: partyList = [] } = useFetchWithBody({
    url: apiRoute.transactionEntry.getPartyList,
    queryKey: ["parties", compCode],
    inputData: { compCode },
  });

  const { mutate: insertOutstanding, isPending } = usePost({
    queryKey: "outstandingInsert",
    url: apiRoute.transactionEntry.insertOutstandingBill,
    successMessage: "Outstanding Bill Inserted Successfully",
    onSuccessTasks: (data) => {
       dispatch(setNewEntryMode(true))
      if (submitbtnid === 'btnsave') {
        navigate(linksUrl.outstandingBillEntry.billEntryMaster)

        // setFormData({
        //   ...formData,
        //   Bill_Type: "",
        //   Trade_Of: "",
        //   Ac_Id: "",
        //   PAc_Id: "",
        //   Bill_Date: null,
        //   Bill_No: "",
        //   Br_Id: "",
        //   NETAMTD: "",
        //   CRATE: "",
        //   NetAmt: "",
        //   BillYN: "1",
        //   Remark: "",
        // })
      }
      else if (submitbtnid === 'btnsavenew') {
        setFormData({
          ...formData,
          PAc_Id: "",
          Bill_No: "",
          Br_Id: "",
          NETAMTD: "",
          CRATE: "",
          NetAmt: "",
          BillYN: "",
          Remark: "",
        })
      }
    }
  });

  const { mutate: updateOutstanding, isError, isPending: isUpdatePending } = usePost({
    queryKey: "outstandingUpdate",
    url: apiRoute.transactionEntry.updateOutstandingBill, // 🔁 You need to define this API route
    successMessage: "Outstanding Bill Updated Successfully",
    onSuccessTasks: (data) => {
      dispatch(setNewEntryMode(true))
      if (submitbtnid === 'btnsavenew') {
        setFormData({
          ...formData,
          PAc_Id: "",
          Bill_No: "",
          Br_Id: "",
          NETAMTD: "",
          CRATE: "",
          NetAmt: "",
          BillYN: "",
          Remark: "",
        })
      }
      else {
        navigate(linksUrl.outstandingBillEntry.billEntryMaster)
      }
    },
  });

  useEffect(() => {
    if (!isNewEntry && detailParams) {
      setFormData({
        Ac_Year,
        CompCode: compCode,
        DY,
        Bill_Type: detailParams?.Bill_Type ?? "",
        Trade_Of: detailParams?.Trade_Of ?? "",
        Ac_Id: detailParams?.Ac_Id ?? "",
        PAc_Id: detailParams?.PAc_Id ?? "",
        Bill_Date: detailParams?.Bill_Date ?? null,
        // detailParams?.Bill_Date ?? null,
        Bill_No: detailParams?.Bill_No ?? "",
        Br_Id: detailParams?.Br_Id ?? "",
        NETAMTD: detailParams?.NETAMTD ?? 0,
        CRATE: detailParams?.CRATE ?? 0,
        NetAmt: detailParams?.NetAmt ?? 0,
        BillYN:String(detailParams?.BillYN) ?? "1",
        Remark: detailParams?.Remark ?? "",
      });
    }
  }, [isNewEntry, detailParams, partyData, brokerList]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      BillYN: e.target.checked ? "1" : "0",
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const start = new Date(startDate);
    const billdate = new Date(formData.Bill_Date)
    if (billdate < start) {

      const sanitizeNumber = (val) => {
        return val === "" || val === undefined ? null : parseFloat(val).toFixed(2);
      };
      const btnid = e.nativeEvent.submitter.id;
      setSubmitbtnid(btnid)
      const payload = {
        ...formData,
        D_Id: formData.Ac_Id,
        Chal_No: formData.Bill_No,
        Vou_No: formData.Bill_No,
        NETAMTD: sanitizeNumber(formData.NETAMTD),
        CRATE: sanitizeNumber(formData.CRATE),
        GrossAmtD: sanitizeNumber(formData.NETAMTD),
        NetAmt: sanitizeNumber(formData.NetAmt),
        GrossAmt: sanitizeNumber(formData.NetAmt),
      };
      // insertOutstanding({ data: payload });
      if (isNewEntry) {
        insertOutstanding({ data: payload });
      } else {
        updateOutstanding({ data: { ...payload, TransactionID: detailParams.TransactionID } }); // ✅ Send update identifier
      }
    }
    else {
      toast.error(dateError, {
        position: "top-center"
      })
    }
  };
  useEffect(() => {
    const netAmtD = parseFloat(formData.NETAMTD);
    const rate = parseFloat(formData.CRATE);

    if (!isNaN(netAmtD) && !isNaN(rate)) {
      setFormData((prev) => ({
        ...prev,
        NetAmt: (netAmtD * rate).toFixed(2),
      }));
    }
  }, [formData.NETAMTD, formData.CRATE]);

  const formatToDDMMYY = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = String(d.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  };
  if (isError) {
    return <ErrorCard />
  }

  if (isUpdatePending) {
    return <LoadingCard />
  }

  return (
    <MainContainer
      pageName="Outstanding Bill Entry"  // Changed from "Purity Entry" to match your content
      breadcrumbs={["Master", "Outstanding Bill Entry"]}  // Updated to match your context
      prevPage={{
        show: true,
        onClick: () => navigate(linksUrl.outstandingBillEntry.billEntryMaster)  // Updated to your outstanding entry URL
      }}
    >
      <Paper elevation={3} sx={{ p: 3 }}>
        {/* <Typography variant="h6" gutterBottom>
          Outstanding Bill Entry
        </Typography> */}
        {/* Date Error Dialog */}
        {/* <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle>Invalid Date</DialogTitle>
          <DialogContent>
            Bill date must be before company start date ({formatToDDMMYY(startDate)})
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)}>OK</Button>
          </DialogActions>
        </Dialog> */}

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Bill Type Dropdown */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Bill Type</InputLabel>
                <Select
                  name="Bill_Type"
                  label="Bill Type"
                  value={formData.Bill_Type}
                  size="small"
                  onChange={handleChange}
                  required

                >
                  <MenuItem value="P">Purchase</MenuItem>
                  <MenuItem value="S">Sales</MenuItem>
                  <MenuItem value="PR">Purchase Return</MenuItem>
                  <MenuItem value="SR">Sales Return</MenuItem>
                  <MenuItem value="I">Job Income</MenuItem>
                  <MenuItem value="J">Job Expense</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Trade Of Dropdown */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Trade Of</InputLabel>
                <Select
                  size="small"
                  label="Trade Of"
                  name="Trade_Of"
                  value={formData.Trade_Of}
                  onChange={handleChange}
                  required
                >
                  <MenuItem value="">None</MenuItem>
                  <MenuItem value="R">Rough</MenuItem>
                  <MenuItem value="P">Polish</MenuItem>
                  <MenuItem value="J">Rejection</MenuItem>
                  <MenuItem value="U">Non Makeable</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Account Dropdown */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Account</InputLabel>
                <Select
                  name="Ac_Id"
                  size="small"
                  label="Account"
                  value={formData.Ac_Id}
                  onChange={handleChange}
                  required
                >
                  {partyData.map((party) => (
                    <MenuItem key={party.AC_ID} value={party.AC_ID}>
                      {party.AC_DESC}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Party (PAc_Id) Dropdown */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined">
                <InputLabel >Party</InputLabel>
                <Select
                  name="PAc_Id"
                  size="small"
                  label="Party"
                  value={formData.PAc_Id}
                  onChange={handleChange}
                >
                  {partyList.map((party) => (
                    <MenuItem key={party.Party_Id} value={party.Party_Id}>
                      {party.Party_Name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>


            {/* Bill Date */}
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={"Bill Date"}
                  views={["day", "month", "year"]}
                  format="DD/MM/YYYY"
                  value={
                    formData.Bill_Date
                      ? dayjs(formData.Bill_Date)
                      : formData.Bill_Date
                  }
                  onChange={handleDateChange}
                  //isRequired={item.required}
                  className="w-full "
                  slotProps={{
                    textField: { size: "small", error: dateError, helperText: dateError, required: true },
                  }}
                />
              </LocalizationProvider>
              {/* <TextField
                fullWidth
                label="Bill Date"
                type="date"
                name="Bill_Date"
                value={formData.Bill_Date || ""}
                onChange={(e) => {
                  const value = e.target.value; // yyyy-MM-dd
                  handleChange({
                    target: {
                      name: "Bill_Date",
                      value: value, // store yyyy-MM-dd
                    },
                  });
                  validateBillDate(value);
                }}
                required
                InputLabelProps={{ shrink: true }}
                error={!!dateError}
                helperText={dateError}
              /> */}

            </Grid>

            {/* Bill Number */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                label="Bill Number"
                name="Bill_No"
                value={formData.Bill_No}
                onChange={handleChange}
                variant="outlined"
                required
              />
            </Grid>

            {/* Broker Dropdown */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Broker</InputLabel>
                <Select
                  name="Br_Id"
                  size="small"
                  value={formData.Br_Id}
                  label="Broker"
                  onChange={handleChange}

                >
                  {brokerList.map((broker) => (
                    <MenuItem key={broker.Party_Id} value={broker.Party_Id}>
                      {broker.Party_Name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Net Amount $ */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Balance Amount in $"
                name="NETAMTD"
                size="small"
                type="number"
                value={formData.NETAMTD}
                onChange={handleChange}
                variant="outlined"
                onBlur={() => {
                  setFormData((prev) => ({
                    ...prev,
                    NETAMTD: prev.NETAMTD ? Number(prev.NETAMTD).toFixed(2) : "",
                  }));
                }}

              />
            </Grid>

            {/* Conversion Rate */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Conversion Rate in ₹"
                name="CRATE"
                type="number"
                size="small"
                value={formData.CRATE}
                variant="outlined"
                onChange={handleChange}
                onBlur={() => {
                  setFormData((prev) => ({
                    ...prev,
                    CRATE: prev.CRATE ? Number(prev.CRATE).toFixed(2) : "",
                  }));
                }}

              />
            </Grid>

            {/* Net Amount */}
            {/* <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Net Amount"
                name="NetAmt"
                type="number"
                value={formData.NetAmt}
                onChange={handleChange}
                required
              />
            </Grid> */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Balance Amount"
                name="NetAmt"
                type="number"
                size="small"
                value={formData.NetAmt}
                onChange={handleChange}
                variant="outlined"
                onBlur={() => {
                  setFormData((prev) => ({
                    ...prev,
                    NetAmt: Number(prev.NetAmt || 0).toFixed(2),
                  }));
                }}
                required
              />
            </Grid>


            {/* Remarks */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Remarks"
                name="Remark"
                size="small"
                value={formData.Remark}
                onChange={handleChange}
                multiline
                rows={3}
              />
            </Grid>
            <div className="flex gap-5  justify-center items-center w-full mt-5">
              {/* Checkbox for BillYN */}

              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.BillYN === "1"}
                    onChange={handleCheckboxChange}
                  />
                }
                label="Is Bill?"
              />


              {/* Submit Button */}

              <Button
                id="btnsave"
                type="submit"
                variant="contained"
                color="primary"
                size="small"
                disabled={isPending || isUpdatePending}
              >
                {isPending || isUpdatePending
                  ? "Submitting..."
                  :"Submit"}
                 
              </Button>
 {/* // : isNewEntry
                  //   ? "Submit"
                  //   : "Update" */}
              <Button
                id="btnsavenew"
                type="submit new"
                variant="contained"
                color="primary"
                size="small"
                disabled={isPending}
              >
                {isPending ? "Submitting..." : "Submit & New"}
              </Button>

            </div>
          </Grid>

        </form>
      </Paper>
    </MainContainer >
  );
};

export default OutstandingBillEntry;
